// 將純文字中的 http(s) URL 轉成可點連結節點；其餘文字不當 raw HTML
import React from 'react';

const URL_RE = /https?:\/\/[^\s<>"')\]]+/gi;

/** @returns {Array<string|React.ReactElement>} */
export function linkifyToNodes(text) {
  const raw = String(text || '');
  if (!raw) return [];
  const nodes = [];
  let last = 0;
  let i = 0;
  const re = new RegExp(URL_RE.source, URL_RE.flags);
  let m;
  while ((m = re.exec(raw)) !== null) {
    if (m.index > last) nodes.push(raw.slice(last, m.index));
    let url = m[0];
    let trail = '';
    const tm = url.match(/[.,;:!?]+$/);
    if (tm) {
      trail = tm[0];
      url = url.slice(0, -trail.length);
    }
    if (url) {
      nodes.push(
        <a key={`a${i++}`} href={url} target="_blank" rel="noopener noreferrer">
          {url}
        </a>
      );
    }
    if (trail) nodes.push(trail);
    last = m.index + m[0].length;
  }
  if (last < raw.length) nodes.push(raw.slice(last));
  return nodes;
}

export default linkifyToNodes;
